export const getHeadingInDegrees = (value?: unknown, fallback = "unknown") => {
  if (typeof value !== "number" || !Number.isFinite(value)) {
    return fallback;
  }

  // Normalize to 0–359 if you want (optional)
  const deg = ((Math.round(value) % 360) + 360) % 360;

  return `${deg}°`;
};
